import { getOperatorOptions } from '../logicHelpers'

const utmSource = () => {
  return {
    types: [
      { label: 'UTM Source', value: 'utm_source' },
      { label: 'UTM Medium', value: 'utm_medium' },
      { label: 'UTM Campaign', value: 'utm_campaign' },
      { label: 'UTM Term', value: 'utm_term' },
      { label: 'UTM Content', value: 'utm_content' }
    ],
    inputs: [
      {
        $formkit: 'select',
        key: 'occurrence-select',
        name: 'occurrence',
        options: [
          { label: 'On most recent occurrence', value: 'last touch' },
          { label: 'On current page', value: 'last' },
          { label: 'On first occurrence', value: 'first touch' },
          { label: 'On first ever page hit', value: 'first' },
          { label: 'On any occurrence', value: 'any' }
        ],
        can: (condition: { $source: string }) => condition.$source === 'utm'
      },
      {
        $formkit: 'select',
        key: 'operator-select',
        name: 'operator',
        options: getOperatorOptions(),
        can: (condition: { $source: string }) => condition.$source === 'utm'
      },
      {
        $formkit: 'text',
        key: 'value-input',
        name: 'value',
        can: (condition: { $source: string; operator: string }) =>
          condition.$source === 'utm' &&
          condition.operator !== 'is set' &&
          condition.operator !== 'is not set'
      }
    ]
  }
}

export default utmSource
